/* eslint-disable object-curly-newline */
import Button from 'common/components/Button/Button';
import Modal from 'common/components/Modal/Modal';
import TranslatedText from 'common/components/TranslatedText/TranslatedText';
import AlertsContext from 'common/contexts/alerts';
import useFurniture from 'furnitures/contexts/furnitures';
import FurnitureForm from 'furnitures/pages/FurnitureFormPage/FurnitureForm';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useBeachEditor from 'sites/pages/BeachEditor/contexts/beachEditor';

const FurnitureSelector = () => {
  const { t } = useTranslation();
  const { setAlert } = useContext(AlertsContext);

  const {
    save, update, remove, fetchItems: fetchFurnitures, items: furnitures,
  } = useFurniture();

  const {
    setSelectedSelector, selectedSelector, mode, updateSeatInformation, site,
  } = useBeachEditor();

  const [showModal, setShowModal] = useState(false);
  const [selectedFurnitureModal, setSelectedFurnitureModal] = useState(null);

  const handleOpenModal = useCallback((furniture) => {
    setSelectedFurnitureModal(furniture);
    setShowModal(true);
  }, [setShowModal]);

  const handleDelete = useCallback(async (row) => {
    await remove(row.id);
    await fetchFurnitures();
  }, [remove, fetchFurnitures]);

  const handleSubmitModal = useCallback(async (data) => {
    const payload = { ...data };

    if (data.id) {
      const res = await update(payload.id, payload);

      if (!res.error) {
        setAlert(t('furnitures.successEdit'), 'success');
        fetchFurnitures();
        setShowModal(false);
      } else {
        setAlert(res.message, 'danger');
      }
    } else {
      const res = await save(payload);

      if (!res.error) {
        setAlert(t('furnitures.successAdd'), 'success');
        fetchFurnitures();
        setShowModal(false);
      } else {
        setAlert(res.message, 'danger');
      }
    }
  }, [fetchFurnitures, save, setAlert, t, update]);

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
  }, [setShowModal]);

  useEffect(() => {
    if (mode === 'furniture' && furnitures?.length) {
      setSelectedSelector({
        id: furnitures[0].id,
        type: 'furniture',
        furniture: furnitures[0],
      });
    }
  }, [mode, furnitures, setSelectedSelector]);

  useEffect(() => {
    fetchFurnitures();
  }, [fetchFurnitures]);

  useEffect(() => {
    if (furnitures?.length) {
      updateSeatInformation('furniture', furnitures);
    }
  }, [furnitures, updateSeatInformation]);

  return (
    <div className="selector-panel">
      { showModal && (
      <Modal confirmModal={() => {}} closeModal={handleCloseModal}>
        <FurnitureForm
          site={site.id}
          onSubmit={handleSubmitModal}
          furniture={selectedFurnitureModal}
        />
      </Modal>
      )}
      <Button
        color="primary"
        label={t('furnitures.furnitureAdd')}
        icon="fa-plus"
        onClick={handleOpenModal}
      />
      <div className="selectors">
        { furnitures && furnitures.map((item, index) => (
          <div
            key={index}
            alt={item.name}
            className={`selector ${item.id === selectedSelector.id && 'selected'}`}
            onClick={
              () => setSelectedSelector({
                id: item.id,
                type: 'furniture',
                furniture: item,
              })
            }
          >
            <img
              alt={item.name}
              src={`${process.env.REACT_APP_API_URL}${item.image.url}`}
            />
            <div className="selectorName">
              <TranslatedText value={item.name} />
              {item.id === selectedSelector.id && (
                <p>
                  {t('common.clicOnMap')}
                </p>
              )}
            </div>
            <div className="actionsButton">
              <Button
                onClick={() => handleOpenModal(item)}
                icon="fa-pencil-alt"
                color="primary"
                transparent
              />
              <Button
                onClick={() => handleDelete(item)}
                icon="fa-trash-alt"
                color="danger"
                confirm
                transparent
                confirmMessage={t('furnitures.confirmDelete')}
              />
            </div>

          </div>
        ))}
        <div
          className={`selector ${selectedSelector.id === 'delete' && 'selected'}`}
          onClick={() => {
            setSelectedSelector({
              id: 'delete',
              type: 'furniture',
              furniture: null,
            });
          }}
        >
          <i className=" selector-icon fas fa-trash-alt" />
          <div className="selectorName">
            {t('common.delete')}
            {selectedSelector.id === 'delete' && 'selected' && (
            <p>
              {t('common.clicOnMapDelete')}
            </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FurnitureSelector;
